// All UI copy for FR & EN. Content from backend already comes in both languages.

export const translations = {
  fr: {
    nav: {
      services: "Services",
      portfolio: "Portfolio",
      about: "Studio",
      pricing: "Tarifs",
      blog: "Journal",
      contact: "Contact",
      quote: "Demander un devis",
    },
    hero: {
      eyebrow: "Studio de production — Moncton, NB",
      title_a: "Révélez",
      title_b: "votre vraie",
      title_c: "nature",
      sub: "Phaneroo Prod conçoit des films, photographies et contenus cinématographiques pour les marques qui refusent l'invisible.",
      cta_quote: "Démarrer un projet",
      cta_reel: "Voir la bande démo",
      stat_1: "Projets livrés",
      stat_2: "Années d'expertise",
      stat_3: "Provinces couvertes",
    },
    services: {
      eyebrow: "Ce que nous savons faire",
      title: "Cinéma, image fixe et tout l'écosystème autour.",
      items: [
        { tag: "01", k: "Production vidéo", d: "Films de marque, portraits de fondateurs, événements, témoignages, démos produits — montés pour durer." },
        { tag: "02", k: "Photographie", d: "Portraits éditoriaux, équipes, espaces et produits — éclairés avec intention." },
        { tag: "03", k: "Contenu social", d: "Réels, capsules verticales et systèmes d'épisodes pour Instagram, TikTok, LinkedIn et YouTube." },
        { tag: "04", k: "Drone & aérien", d: "Cinématographie aérienne au-dessus des paysages des Maritimes — drone certifié RPAS." },
        { tag: "05", k: "Direction artistique", d: "Identité visuelle, direction photo, scénarisation et systèmes de marque cohérents." },
      ],
    },
    portfolio: {
      eyebrow: "Travaux récents",
      title: "Quelques histoires que nous avons portées à l'image.",
      view_all: "Voir tout le portfolio",
      filter: {
        all: "Tout",
        video: "Vidéo",
        photo: "Photo",
        drone: "Drone",
        social: "Social",
        branding: "Image de marque",
      },
    },
    about: {
      eyebrow: "Le studio",
      title: "Nous croyons à la retenue, à l'histoire et au métier.",
      p1: "Phaneroo Prod est un studio basé à Moncton qui produit du contenu vidéo et photographique pour les marques d'Atlantique Canada et au-delà. Notre nom — Phaneroo — signifie « rendre visible ». C'est précisément ce que nous faisons : nous rendons votre histoire visible.",
      p2: "Chaque projet commence par une conversation, pas par un devis. Nous écoutons longtemps avant d'écrire un brief, et plus longtemps encore avant d'allumer une caméra.",
      bullets: ["Réponse en moins de 24 heures", "Tournage et montage à l'interne", "Devis transparent, sans surprise"],
    },
    testimonials: { eyebrow: "Témoignages", title: "Les marques qui nous ont confié leur image." },
    pricing: {
      eyebrow: "Forfaits",
      title: "Trois façons de travailler ensemble.",
      sub: "Tous nos forfaits incluent un premier appel exploratoire gratuit, un devis transparent et la cession des droits commerciaux.",
      tiers: [
        {
          name: "Essentiel",
          price: "à partir de 1 800 $",
          desc: "Pour une vidéo ou une séance photo unique avec un livrable principal.",
          features: ["Demi-journée de tournage", "Montage 1 version finale", "Licence usage web/sociaux", "Délai 10 jours ouvrables"],
        },
        {
          name: "Signature",
          price: "à partir de 4 500 $",
          desc: "Notre formule la plus populaire pour les marques en lancement ou en repositionnement.",
          features: ["Journée complète de tournage", "Film 60–90s + 3 capsules courtes", "Direction artistique incluse", "2 cycles de révisions", "Cession des droits complète"],
          featured: true,
        },
        {
          name: "Cinéma",
          price: "sur mesure",
          desc: "Productions ambitieuses, multi-jours, scénarisées, avec direction artistique étendue.",
          features: ["2+ journées de tournage", "Équipe étendue (réalisation, son, lumière)", "Direction artistique & scénarisation", "Drone & motion design inclus", "Stratégie de diffusion"],
        },
      ],
      cta: "Demander un devis",
    },
    blog: { eyebrow: "Journal", title: "Notes du studio.", read: "Lire", min: "min" },
    contact: {
      eyebrow: "Travailler ensemble",
      title: "Parlons de votre projet.",
      sub: "Décrivez votre vision, votre échéance et votre marque. Nous répondons en moins de 24 heures.",
      name: "Votre nom",
      email: "Courriel",
      phone: "Téléphone (facultatif)",
      company: "Entreprise (facultatif)",
      project_type: "Type de projet",
      project_options: ["Film de marque", "Photographie", "Contenu social", "Événement", "Drone / aérien", "Direction artistique", "Autre"],
      budget: "Budget approximatif",
      budget_options: ["< 2 000 $", "2 000 – 5 000 $", "5 000 – 15 000 $", "15 000 – 40 000 $", "40 000 $+"],
      target_date: "Date cible (facultatif)",
      message: "Parlez-nous de votre projet…",
      submit: "Envoyer la demande",
      sending: "Envoi…",
      success: "Merci. Nous vous répondons dans les 24 heures.",
      error: "Une erreur est survenue. Réessayez ou écrivez-nous directement.",
    },
    footer: {
      tagline: "Studio de production cinématographique — Moncton, NB.",
      links_title: "Navigation",
      contact_title: "Studio",
      legal_title: "Légal",
      legal: ["Confidentialité", "Mentions légales", "Plan du site"],
      rights: "Tous droits réservés.",
      built: "Phaneroo Ventures.",
    },
    cta_band: {
      title: "Prêt à révéler votre vraie nature ?",
      sub: "Un appel exploratoire de 20 minutes, gratuit, sans engagement.",
      btn: "Réserver un appel",
    },
  },
  en: {
    nav: { services: "Services", portfolio: "Work", about: "Studio", pricing: "Pricing", blog: "Journal", contact: "Contact", quote: "Get a quote" },
    hero: {
      eyebrow: "Production studio — Moncton, NB",
      title_a: "Reveal",
      title_b: "your true",
      title_c: "self",
      sub: "Phaneroo Prod crafts cinematic films, photography and content for brands that refuse to be invisible.",
      cta_quote: "Start a project",
      cta_reel: "Watch the reel",
      stat_1: "Projects delivered",
      stat_2: "Years of craft",
      stat_3: "Provinces covered",
    },
    services: {
      eyebrow: "What we do",
      title: "Cinema, stills, and the whole ecosystem around them.",
      items: [
        { tag: "01", k: "Video production", d: "Brand films, founder stories, events, testimonials and product demos — cut to last." },
        { tag: "02", k: "Photography", d: "Editorial portraits, teams, spaces and products — lit with intention." },
        { tag: "03", k: "Social content", d: "Reels, vertical capsules and episode systems for Instagram, TikTok, LinkedIn and YouTube." },
        { tag: "04", k: "Drone & aerial", d: "Aerial cinematography across the Maritimes — RPAS-certified pilots." },
        { tag: "05", k: "Art direction", d: "Visual identity, photo direction, scripting and consistent brand systems." },
      ],
    },
    portfolio: { eyebrow: "Recent work", title: "A few stories we helped bring to the screen.", view_all: "View the full portfolio",
      filter: { all: "All", video: "Video", photo: "Photo", drone: "Drone", social: "Social", branding: "Branding" } },
    about: {
      eyebrow: "The studio",
      title: "We believe in restraint, story, and craft.",
      p1: "Phaneroo Prod is a Moncton-based studio producing video and photo for brands across Atlantic Canada and beyond. Our name — Phaneroo — means 'to make visible'. That is precisely what we do: we make your story visible.",
      p2: "Every project begins with a conversation, not a quote. We listen long before writing a brief, and longer still before turning on a camera.",
      bullets: ["Reply within 24 hours", "Shot & edited in-house", "Transparent quote, no surprises"],
    },
    testimonials: { eyebrow: "Testimonials", title: "Brands that trusted us with their image." },
    pricing: {
      eyebrow: "Packages",
      title: "Three ways to work together.",
      sub: "All packages include a free discovery call, transparent pricing, and full commercial rights.",
      tiers: [
        { name: "Essential", price: "from $1,800", desc: "For a single video or photo session with a primary deliverable.",
          features: ["Half-day shoot", "1 final edit", "Web & social license", "10 business-day turnaround"] },
        { name: "Signature", price: "from $4,500", desc: "Our most popular package for brands launching or repositioning.",
          features: ["Full-day shoot", "60–90s film + 3 short cutdowns", "Art direction included", "2 revision cycles", "Full commercial rights"], featured: true },
        { name: "Cinema", price: "custom", desc: "Ambitious, multi-day, scripted productions with extended art direction.",
          features: ["2+ shoot days", "Extended crew (director, sound, gaffer)", "Art direction & scripting", "Drone & motion design included", "Distribution strategy"] },
      ],
      cta: "Request a quote",
    },
    blog: { eyebrow: "Journal", title: "Notes from the studio.", read: "Read", min: "min" },
    contact: {
      eyebrow: "Let's work",
      title: "Tell us about your project.",
      sub: "Describe your vision, your timeline and your brand. We reply within 24 hours.",
      name: "Your name", email: "Email", phone: "Phone (optional)", company: "Company (optional)",
      project_type: "Project type",
      project_options: ["Brand film", "Photography", "Social content", "Event", "Drone / aerial", "Art direction", "Other"],
      budget: "Approximate budget",
      budget_options: ["< $2,000", "$2,000 – $5,000", "$5,000 – $15,000", "$15,000 – $40,000", "$40,000+"],
      target_date: "Target date (optional)",
      message: "Tell us about your project…",
      submit: "Send request", sending: "Sending…",
      success: "Thank you. We'll be in touch within 24 hours.",
      error: "Something went wrong. Try again or email us directly.",
    },
    footer: { tagline: "Cinematic production studio — Moncton, NB.", links_title: "Navigate", contact_title: "Studio", legal_title: "Legal",
      legal: ["Privacy", "Legal notice", "Sitemap"], rights: "All rights reserved.", built: "Phaneroo Ventures." },
    cta_band: { title: "Ready to reveal your true self?", sub: "A free 20-minute discovery call, no commitment.", btn: "Book a call" },
  },
};

export default translations;
